import { Locale } from '@ps-smart-cp/ppfw-client';

const eligibleBillingProviderNameConfig = {
  target: new Map([[Locale.ja, '適格請求書発行事業者の対象']]),
  notTarget: new Map([[Locale.ja, '適格請求書発行事業者の対象外 ']]),
} satisfies Record<string, Map<Locale, string>>;

export { eligibleBillingProviderNameConfig };
